import { ComplexListing, ComplexListingMinimal } from '@bit/jimmijoensson.keyhole.interfaces.complex-listing-interface'
import { toNonDecimalLocaleString } from './utils'

export const getComplexDetails = (complex: ComplexListingMinimal | ComplexListing) => [`${complex.numberOfRentals} lejemål`, `Husleje fra DKK. ${toNonDecimalLocaleString(complex.minimumRent, 'da-DK')}`]

export const getShapeUrl = (index: number) => [
  'https://uploads-ssl.webflow.com/5e13379748d7ea83a0e997e3/5e14fe619a07bd677eeef484_light.svg',
  'https://uploads-ssl.webflow.com/5e13379748d7ea83a0e997e3/5e16fb62ef00e7bbda6cca5d_hole%20k.svg',
  'https://uploads-ssl.webflow.com/5e13379748d7ea83a0e997e3/5e164eda496c013a873303d1_Vectorsad.svg',
  'https://uploads-ssl.webflow.com/5e13379748d7ea83a0e997e3/5e14863f2c28778935bf480e_Keyhole-Graphic-K.svg',
][index % 4]
